// const CustomButton = ({ label, onClick, type = "button", icon, variant = "primary" }) => {
//   return (
//     <button
//       type={type}
//       className={`custom-btn btn-${variant}`}
//       onClick={onClick}
//     >
//       {icon && <i className={`bi ${icon} me-2`}></i>}
//       {label}
//     </button>
//   );
// };

// export default CustomButton;

import React from "react";
import { Link } from "react-router-dom";
import '../Utils/custumButton.css';
import { throttleClick } from "./throttle";

const CustomButton = ({
  label,
  onClick,
  type = "",
  icon,
  disabled= false,
  variant = "outline",
  appendClass = "",
  iconAppendClass = "",
  to, // <-- optional link
  updateBgColor = '#EF5713',
  btnWidth = "fit-content",
  customStyles = {}
}) => {
  const content = (
    <>
      {icon && <i className={`bi ${icon} fw-bold ${iconAppendClass}`}></i>}
      {label}
    </>
  );

  if (to) {
    // If `to` prop exists → render Link
    return (
      <Link to={to} className={`custom-btn-outline btn-${variant} ${appendClass}`} style={{backgroundColor:updateBgColor}}>
        {content}
      </Link>
    );
  }

  // Else render regular button
  return (
    <button
      type={type}
      disabled={disabled}
      className={Object.keys(customStyles).length > 0  ? '' : `custom-btn-outline btn-${variant} ${appendClass}` }
      onClick={(e) => {
    if (!onClick) return;

    if (label) {
      throttleClick(label || icon, () => onClick(e));
    } else {
      onClick(e);
    }
  }}
      // onClick={onClick}
      style={Object.keys(customStyles).length > 0 ? customStyles : {backgroundColor:disabled?"grey":updateBgColor, width: btnWidth}}
    >
      {content}
    </button>
  );
};

export default CustomButton;
